<template>
    <div style="width:100%">
            <v-form style="width:100%" ref="userForm">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex m12>
                            <v-banner class="green text--black font-weight-bold" v-if="user.status == 'A'">
                                <v-icon>mdi-check-circle</v-icon>
                                User is Active
                                <template v-slot:actions>
                                    <v-btn text v-on:click="deactivate()">Deactivate</v-btn>
                                </template>
                            </v-banner>

                            <v-banner class="orange lighten-1 text--black font-weight-bold" v-if="user.status == 'I'">
                                <v-icon>mdi-check-circle</v-icon>
                                User is Inactive
                                <template v-slot:actions>
                                    <v-btn text v-on:click="activate()">Activate</v-btn>
                                </template>

                            </v-banner>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md3>
                            <v-text-field label="E-Mail (User Name)"
                                          v-model="user.email"
                                          counter="100"
                                          :disabled="true"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex md3>
                            <v-text-field counter="100" label="First Name" v-model="user.firstName" :rules="serverValidation('firstName','First Name')"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field counter="100" label="Middle Name" v-model="user.middleName"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field counter="100" label="Last Name" v-model="user.lastName" :rules="serverValidation('lastName','Last Name')"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex md3>
                            <v-text-field counter="100" label="Alias" v-model="user.alias"></v-text-field>
                        </v-flex>
                        <v-flex md3>
                            <v-text-field label="Phone Number" v-model="user.phoneNumber"
                                          v-mask="'(###) ### - ####'"></v-text-field>
                        </v-flex>
                        <v-flex md3 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                            <v-tooltip v-model="globalAdminTooltip" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-checkbox label="Global Admin"
                                                v-on="on"
                                                v-model="user.globalAdmin"
                                    ></v-checkbox>
                                </template>
                                <span>Grants User Access to All Organizations. Use only for CPS Employees</span>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-btn outlined type="button" class="mx-2" @click="resetPassword()"  color="info" :disabled="overlay" dark>Change Password</v-btn>
                        <v-btn outlined type="button" class="mx-2" @click="confirmResetPasswordViaEmail()"  color="info" :disabled="overlay" dark>Reset Password Via E-Mail</v-btn>
                        <v-btn outlined type="button" class="mx-2" @click="revokeToken()"  color="error" :disabled="overlay" dark>Revoke Token</v-btn>
                        <v-btn outlined type="button" class="mx-2" @click="deleteUser()"  color="error" :disabled="overlay" dark v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN') && $userHolder.getUserId() != user.id">Delete User</v-btn>
                        <v-btn outlined type="button" class="mx-2" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                        <v-progress-circular
                                :width="3"
                                v-show="overlay"
                                color="red"
                                indeterminate="">
                        </v-progress-circular>
                    </v-layout>
                </v-container>
            </v-form>
            <confirm-dialog ref="confirmDialog"></confirm-dialog>
            <alert-dialog ref="alertDialog"></alert-dialog>
            <v-dialog v-model="resetPasswordDialog" persistent max-width="400">
                <v-card>
                    <v-form ref="userResetPasswordForm" @submit="doResetPassword()" onsubmit="return false">
                        <v-card-title>
                            <span class="headline">Reset Password</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex md12>
                                        <v-text-field v-model="newPassword" :rules="serverValidation('resetPassword.password','Password')" type="password" label="Password" required></v-text-field>
                                    </v-flex>
                                    <v-flex md12>
                                        <v-text-field v-model="confirmNewPassword"  type="password" label="Confirm Password" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn outlined type="button" color="warning" text @click="closeResetPasswordDialog()" :disabled="passwordOverlay">Cancel</v-btn>
                            <v-btn outlined type="submit" color="green darken-1" text @click="doResetPassword()" :disabled="passwordOverlay">Reset</v-btn>
                            <v-progress-circular
                                    :width="3"
                                    v-show="passwordOverlay"
                                    color="red"
                                    indeterminate="">
                            </v-progress-circular>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
    </div>
</template>

<script>
    import {validationMixin} from '@/mixins/validations'
    import ConfirmDialog from "@/components/common/ConfirmDialog";
    import AlertDialog from "@/components/common/AlertDialog";
    import api from '@/api';
    export default {
        inject: ['getProvidedUser','getProvidedUserOrg'],
        mixins:[validationMixin],
        components : {ConfirmDialog,AlertDialog},
        data() {
            return {
                user : {},
                context : null,
                userId : null,
                organizationId : null,
                organization: {},
                organizations: [],
                resetPasswordDialog : false,
                newPassword : null,
                confirmNewPassword : null,
                passwordOverlay : false,
                overlay:false,
                globalAdminTooltip : false
            }
        },
        created: function() {
            if (this.$route.params.userId) {
                this.userId = this.$route.params.userId;
            }

            this.user = this.getProvidedUser();
            this.organization = this.getProvidedUserOrg();
            this.overlay = false;
        },
        methods: {
            confirmResetPasswordViaEmail() {
                this.$refs.confirmDialog.open('Send Reset Password Email','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        this.doResetPasswordViaEmail();
                    }
                })
            },
            doResetPasswordViaEmail() {
                this.$root.$emit('showGlobalOverlay');
                api.user.password.email.post(this.user.id).then((result) => {
                    this.$root.$emit('hideGlobalOverlay');
                    if (result && result.success) {
                        this.$refs.alertDialog.open('Success',result.message);
                    } else {
                        this.$refs.alertDialog.open('Error',"An Error Occurred Sending An Email");
                    }
                });
            },
            deleteUser() {
                this.$refs.confirmDialog.open('Delete','Are You Sure You Want To Delete This User? This CANNOT Be Undone!').then((confirm) => {
                    if (confirm) {
                        this.doDeleteUser();
                    }
                })
            },
            doDeleteUser() {
                this.$root.$emit('showGlobalOverlay');
                api.user.delete(this.user.id).then(()=> {
                    this.$router.replace('/user');
                },(error) => {
                    console.log(error);
                    const message = error.message ? error.message : 'An Unknown Error Occurred Deleting This User';
                    this.$refs.alertDialog.open('Error',message);
                }).then(()=> {
                    this.$root.$emit('hideGlobalOverlay');
                });
            },
            deactivate : function() {
                api.user.status.post(this.userId,"I").then((data) => {
                    this.user = data;
                    this.$root.$emit('globalMessage','User Deactivated');
                    this.$root.$emit('userStatusUpdated');
                },(error) => {
                    this.processErrors(error);
                });
            },
            activate : function() {
                api.user.status.post(this.userId,"A").then((data) => {
                    this.user = data;
                    this.$root.$emit('globalMessage','User Activated');
                    this.$root.$emit('userStatusUpdated');
                },(error) => {
                     this.processErrors(error);
                });
            },
            save : function() {
                this.violations = null;
                this.$refs.userForm.validate();
                this.updateUser().then(() => {
                    this.$root.$emit('globalMessage','User Updated');
                }).catch(() => {

                });
            },
            updateUser : function() {
                this.overlay = true;
                const that = this;

                return new Promise((resolve,reject) => {
                   api.user.patch(this.user).then(response => {
                        that.user = response;
                        resolve();
                   },(error) => {
                       if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                           this.$refs.userForm.validate();
                       }
                       reject();
                   }).finally(() => {
                       this.overlay = false;
                   });
                });
            },
            resetPassword : function() {
                this.resetPasswordDialog = true;
            },
            closeResetPasswordDialog() {
                this.resetPasswordDialog = false;
                this.violations = [];
                this.newPassword = '';
                this.confirmNewPassword = '';
                this.passwordOverlay = false;
            },
            doResetPassword : function() {
                if (!this.newPassword || !this.confirmNewPassword || this.newPassword != this.confirmNewPassword) {
                    this.$root.$emit('globalError','Passwords Do Not Match');
                    return;
                }
                this.passwordOverlay = true;
                api.user.password.post(this.user.id,this.newPassword).then(() => {
                    this.resetPasswordDialog=false;
                    this.$root.$emit('globalMessage','Password Updated');
                    this.newPassword = '';
                    this.confirmNewPassword = '';
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.userResetPasswordForm.validate();
                    }
                }).finally(() => {
                    this.passwordOverlay = false;
                });
            },
            goBack() {
                this.$router.go(-1);
            },
            revokeToken() {
                api.user.token.delete(this.userId).then(()=> {
                    this.$root.$emit('globalMessage','Token Revoked');
                },() => {
                    this.$root.$emit('globalError','Error Revoking Token');
                });
            }
        }

    }

</script>

